import React from 'react'
import CompanyDashboard from '../components/companies/CompanyDashboard'
import DashBoardTable from '../components/companies/DashBoardTable'

const CompanyMainPage = () => {
  return (
    <div>
      {/* <CompanyDashboard/> */}
      <DashBoardTable/>
    </div>
  )
}

export default CompanyMainPage
